// components/modal/CommentDeleteModal.tsx
import Spinner from "../spinner/Spinner";
import ModalIcon from "../../assets/img/dashboard/modal-icon.png";
import styles from "./CommentDeleteStyles.module.css";
import {useCommentDeleteModal} from "../../context/CommentDeleteModalContext";

const CommentDeleteModal = () => {
  const {isOpen, loading, confirmDelete, closeModal} = useCommentDeleteModal();

  if (!isOpen) return null;

  return (
    <div className={styles.deletePrompt}>
      <div className={styles.deletePromptMainContainer}>
        <span className="fa-solid fa-xmark" onClick={closeModal}></span>
        <img src={ModalIcon} alt="Modal icon" className={styles.deleteIcon} />
        <h1>Are you sure you want to delete this comment?</h1>
        <button onClick={confirmDelete}>
          {loading ? (
            <Spinner variant="small-spinner" alignSpin="center-spinner" />
          ) : (
            "YES"
          )}
        </button>
      </div>
    </div>
  );
};

export default CommentDeleteModal;
